import { api, type Novedad } from "@/lib/api";
import { aPayloadCumplido } from "@/lib/avance";
import { useFormularioNovedad } from "./useFormularioNovedad";

/**
 * Lógica de "Marcar como cumplido" un sub-hito (sin JSX): es el formulario de la novedad (fecha, explicación, fotos y
 * aviso), pero el alta va a `POST /avance/hitos/{id}/completar`, que arma el título ("Hito cumplido: …") y deja el
 * sub-hito completado. Las fotos se suben después a esa novedad, con el mismo reintento que una novedad común.
 */
export function useFormularioCumplido(fid: number, hitoId: number, alGuardar: () => void, avisar = true) {
  return useFormularioNovedad(fid, null, alGuardar, {
    avisar,
    titulo: "Hito cumplido", // no se manda: sólo para que la validación del formulario de novedad pase
    crear: (form) => api.post<Novedad>(`/api/fideicomisos/${fid}/avance/hitos/${hitoId}/completar`, aPayloadCumplido(form)),
  });
}
